import { getUnique } from "@/utils/number/unique";
import { formatDate } from "@/utils/date/format";

function formatBalance(balance) {
    balance = +balance;
    balance = Math.round(balance);
    return balance;
}

export function AccountOperation(data) {
    this.isShowRow = true;
    this.unique = getUnique();
    
    this.id = {
        value: data.id
    };

    this.date_user = {
        value: data.date_user
    };

    this.date_created = {
        value: data.date_created
    };

    this.balance = {
        value: formatBalance(data.balance)
    };
    
    this.balance_end = {
        value: formatBalance(data.balance_end)
    };
    
    // this.sum_salary = {
    //     value: formatBalance(data.sum_salary)
    // };
    
    // this.dynamic = {
    //     value: formatBalance(data.sum_dynamic)
    // };
    
    // this.bonus = {
    //     value: formatBalance(data.sum_bonus)
    // };

    // this.penalty = {
    //     value: formatBalance(data.sum_penalty)
    // };

    this.amount_before = {
        value: data.amount_before
    };

    this.amount = {
        value: data.amount
    };

    this.amount_after = {
        value: data.amount_after
    };



    this.added_amount = {
        style: "color: #12C971",
        value: data.amount > 0 ? data.amount : null
    };

    this.withdraw_amount = {
        style: "color: #FF238D",
        value: data.amount < 0 ? data.amount : null
    };

    // this.penalty = {
    //     value: formatBalance(data.sum_penalty)
    // };

    this.reason = {
        value: data.reason
    };

    this.reason_id = {
        value: data.reason_id
    };

    this.transaction_id = {
        value: data.transaction_id
    };

    this.bonus_fine_id = {
        value: data.bonus_fine_id
    };

    this.bonus_fine_type_id = {
        value: data.bonus_fine_type_id || null
    };

    this.vacation_id = {
        value: data.vacation_id
    };

    this.comment = {
        value: data.comment
    };

    this.delete_author = data.delete_author;

    this.worker = data.worker ? data.worker : null;

    this.delete_date = {
        removed: true,
        value: data.delete_date
    };

    this.delete_comment = {
        removed: true,
        value: data.delete_comment
    };

    this.calculation = null;
    if (data.calculation) {
        this.calculation = {
            id: data.calculation.id,
            filial: data.calculation.filial_name,
        };
    }


    // // 
    this.date_changed = {
        value: data.date_changed
    };

    this.filial = {
        value: data.filial
    };

    this.filial_id = {
        value: data.filial_id
    };

    this.filial_name = {
        value: data.filial_name
    };

    this.company = {
        value: data.company
    };

    this.company_id = {
        value: data.company_id
    };

    this.company_name = {
        value: data.company_name
    };

    this.post = {
        value: data.post
    };

    this.post_code = {
        value: data.post_code
    };

    this.post_name = {
        value: data.post_name
    };

    this.post_code = {
        value: data.post_code
    };

    this.post_code_group_code = {
        value: data.post_code_group_code
    };

    this.post_code_group_name = {
        value: data.post_code_group_name
    };

    this.author = data.author;

    this.author_create = data.author_create;

    this.author_update = data.author_update ;

    this.transaction_method = {
        value: data.transaction_method
    };

    this.transaction_method_id = {
        value: data.transaction_method_id
    };

    this.transaction_method_name = {
        value: data.transaction_method_name
    };

    this.transaction_type = {
        value: data.transaction_type,
        style: data.type === "deposit" ? "color: #12C971" : "color: #FF238D"
    };

    this.transaction_type_id = {
        value: data.transaction_type_id
    };

    this.transaction_type_name = {
        value: data.transaction_type_name
    };

    this.money_source = {
        value: data.money_source
    };

    this.money_source_id = {
        value: data.money_source_id
    };

    this.money_source_name = {
        value: data.money_source_name
    };

    this.type_post = {
        value: data.type_post
    };

    this.type = {
        value: data.type
    };
}
